import Chuck from './chuck.svg';
import Roller from './roller.svg';

export default {
  Chuck,
  Roller,
};
